import { BlocksContent } from '@strapi/blocks-react-renderer'
import { NestedData, SCta } from 'src/rest/types/api/Common'
import { SImageData } from 'src/rest/types/api/Image'
import { STheme } from 'src/rest/types/api/Theme'

export enum ImagePosition {
  Left = 'left',
  Right = 'right',
}

export type SmallPushBlockProps = {
  __component: string
  id: string | number
  title: string
  description?: BlocksContent
  desktopImage?: SImageData
  mobileImage?: SImageData
  cta: SCta
  imagePosition: ImagePosition
  theme?: NestedData<STheme>
}
